// extracted by mini-css-extract-plugin
module.exports = {"formGroup":"vXIzzP5HyQv5I6l4dBVyV","formLabel":"_2sQJUtt2Ld1A3pm3bgPai-"};